<template>
    <div class="notice-overlay" @click.self="closeModal">
        <div class="notice-popup">
            <div class="notice-body">
                <img :src="$commonUtils.getImageUrl(notice.notice_image)" class="w-100" :class="{ 'cursor-pointer': notice.image_link }" v-if="notice.show_type === 'IMAGE' || notice.show_type === 'MULTI'" @click="onImageClick()" />
                <p class="fw-600" style="padding: 16px 16px 0px 16px" v-html="notice.notice_title" v-if="notice.show_type === 'TEXT' || notice.show_type === 'MULTI' || notice.show_type === 'HTML'"></p>
                <p class="p-16" v-html="notice.notice_content" v-if="notice.show_type === 'TEXT' || notice.show_type === 'MULTI' || notice.show_type === 'HTML'"></p>
            </div>
            <div class="notice-footer hstack">
                <button class="btn w-50 fs-14 fw-600" style="padding: 12px 0px;" @click="hideRecentNotice">다시 보지 않기</button>
                <button class="btn w-50 fs-14 fw-600" style="padding: 12px 0px;" @click="closeModal">닫기</button>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: "NoticeModal",
    props: {
        notice: {
            type: Object,
            required: true
        }
    },
    data() {
        return {

        }
    },
    methods: {
        closeModal() {
            this.$emit('update:showModal', false);
        },

        hideRecentNotice(){
            this.$cookies.set('hide_notice_idx', this.notice.notice_idx );

            this.closeModal();
        },
        onImageClick(){
            if(this.notice.image_link && this.notice.image_link.length > 0){
                window.open(this.notice.image_link, '_blank');
            }
        }
    }    
}
</script>
<style scoped>
    @import "@/css/common.css";
    @import "@/css/style.css";

    .notice-overlay {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.45);
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 16px;
    }

    .notice-popup {
        width: 30%;
        max-width: 560px;
        max-height: 80vh;
        background-color: #fff;
        border-radius: 12px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        box-shadow:
            0 8px 24px rgba(0, 0, 0, 0.12),
            0 2px 8px rgba(0, 0, 0, 0.08);

        @media (max-width: 768px) {
            width: 90%;
            max-width: 90%;
        }
    }

    .notice-body {
        overflow-y: auto;
        flex: 1;
    }

    .notice-footer {
        flex-shrink: 0;
        border-top: 1px solid #E7EBEE;
    }

</style>